import SideMenu, {
  MenuOptions,
  Section,
  MenuImage,
} from "../../components/SideMenu";
import React, { Component } from "react";
import { ToastContainer } from "react-toastify";

class SideMenuView extends Component {
  isSuperUser = false;

  constructor(props) {
    super(props);
    this.isSuperUser = localStorage.getItem("is_super_user");
  }
  render() {
    return (
      <div>
        <SideMenu>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />
          {/*<Section name="Inicial"/>*/}
          {/* <MenuOptions option="Dashboard" to="/home/dashboard" /> */}
          <Section name="Allfast" />
          <MenuImage image={localStorage.establishment_img} />
          <div>
            <Section
              className="font-bold padder m-t m-b-sm"
              name={localStorage.establishment_name}
            />
            {/*this.isSuperUser === 'true' ? (
              <MenuOptions
                option="Dashboard"
                to="/home/dashboard"
              />
            ) : ''*/}
            <MenuOptions
              option="Solicitar serviço"
              to="/home/racesolicitations/"
            />
            <MenuOptions
              option="Solicitações de serviço"
              to="/home/raceshistoric/"
            />
            <MenuOptions
              option="Solicitações de pagamento"
              to="/home/solicitations/"
            />
            <MenuOptions
              option="Bloquear entregador"
              to="/home/disabledriver/"
            />
            {this.isSuperUser === 'true' ? (
              <MenuOptions
                option="Taxa da Chuva"
                to="/home/rainTax"
              />
            ) : ''}
            {/*this.isSuperUser === 'true' ? (
              <MenuOptions
                option="Administração"
                to="/home/Admin"
              />
            ) : ''*/}
            <MenuOptions option="Clientes" to="/home/users" />
            <MenuOptions
              option="Cadastro Cliente"
              to="/home/cielo/MakeATrasactionView"
            />
              {this.isSuperUser === 'true' ? (
                  <MenuOptions
                      option="Pagamento Motoboys"
                      to="/home/motoboys-payment"
                  />
              ) : ''}

            <MenuOptions
              option="Carteira"
              to="/home/wallet"
            />
            {this.isSuperUser === 'true' ? (
              <MenuOptions
                option="Estabelecimentos"
                to="/home/establishment"
              />
            ) : ''}
            <MenuOptions option="Relatórios" to="/home/report" />
            <MenuOptions
              option="Relatórios Financeiro"
              to="/home/financialReport"
            />
          </div>
          <MenuOptions option="Sair" to="/#" />
        </SideMenu>
      </div>
    );
  }
}

export default SideMenuView;



// WEBPACK FOOTER //
// ./src/views/SideMenu/index.js